import { render, staticRenderFns } from "./Borderx.vue?vue&type=template&id=c3806f9a&scoped=true&"
import script from "./Borderx.vue?vue&type=script&lang=js&"
export * from "./Borderx.vue?vue&type=script&lang=js&"
import style0 from "./Borderx.vue?vue&type=style&index=0&id=c3806f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3806f9a",
  null
  
)

export default component.exports